import script from "./publish.vue?vue&type=script&lang=ts&setup=true"
export * from "./publish.vue?vue&type=script&lang=ts&setup=true"

import "./publish.vue?vue&type=style&index=0&id=549cd421&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-549cd421"]])

export default __exports__